import { BrandType, LanguageEnum } from '@/types';
import { RiDiscordFill, RiFacebookFill, RiInstagramFill, RiLinkedinFill, RiRedditFill, RiTelegramFill, RiTiktokFill, RiTwitterFill, RiWhatsappFill, RiYoutubeFill } from 'react-icons/ri';
import { IconType } from 'react-icons';
import { TbWorld } from 'react-icons/tb';
import { __BrandFilterType, __BrandSearchParamsType, __BrandSectionEnum } from './brandDetail.type';
import { nextBrowser } from '@/scripts';
import { PATH } from '@/data';
import { __HiringGenderValue, __JobExperienceValue, __JobPositionTypeValue, __JobSalaryTypeValue, __JobTimeValue } from '../hiringList/hiringList.script';
export const __BrandSocials = (data: BrandType) => {
  const socials: {
    link: string;
    icon: IconType;
    socialName: string;
  }[] = [];
  if (data.youtube) socials.push({
    icon: RiYoutubeFill,
    link: data.youtube,
    socialName: 'youtube'
  });
  if (data.whatsapp) socials.push({
    icon: RiWhatsappFill,
    link: data.whatsapp,
    socialName: 'whatsapp'
  });
  if (data.website) socials.push({
    icon: TbWorld,
    link: data.website,
    socialName: 'website'
  });
  if (data.twitter) socials.push({
    icon: RiTwitterFill,
    link: data.twitter,
    socialName: 'twitter'
  });
  if (data.tiktok) socials.push({
    icon: RiTiktokFill,
    link: data.tiktok,
    socialName: 'tiktok'
  });
  if (data.telegram) socials.push({
    icon: RiTelegramFill,
    link: data.telegram,
    socialName: 'telegram'
  });
  if (data.reddit) socials.push({
    icon: RiRedditFill,
    link: data.reddit,
    socialName: 'reddit'
  });
  if (data.discord) socials.push({
    icon: RiDiscordFill,
    link: data.discord,
    socialName: 'discord'
  });
  if (data.facebook) socials.push({
    icon: RiFacebookFill,
    link: data.facebook,
    socialName: 'facebook'
  });
  if (data.instagram) socials.push({
    icon: RiInstagramFill,
    link: data.instagram,
    socialName: 'instagram'
  });
  if (data.linkedin) socials.push({
    icon: RiLinkedinFill,
    link: data.linkedin,
    socialName: 'linkedin'
  });
  return socials;
};
const __GetBrandSection = (section?: string) => {
  if (section === __BrandSectionEnum.services) return __BrandSectionEnum.services;else if (section === __BrandSectionEnum.ranking) return __BrandSectionEnum.ranking;else if (section === __BrandSectionEnum.hiring) return __BrandSectionEnum.hiring;else return __BrandSectionEnum.services;
};
export const __InitFilterBrand = (e: __BrandSearchParamsType): __BrandFilterType => ({
  section: __GetBrandSection(e.section ? e.section.toString() : undefined),
  // common
  page: e.page ? e.page.toString() : undefined,
  category: e.category ? e.category.toString() : undefined,
  search: e.search ? e.search.toString() : undefined,
  order: e.order ? e.order.toString() : undefined,
  // service
  starGTE: e.starGTE ? Number(e.starGTE) : undefined,
  starLTR: e.starLTR ? Number(e.starLTR) : undefined,
  // hiring
  salaryGTE: e.salaryGTE ? Number(e.salaryGTE) : undefined,
  salaryLTE: e.salaryLTE ? Number(e.salaryLTE) : undefined,
  agreementSalary: e.agreementSalary === 'true' ? true : e.agreementSalary === 'false' ? false : undefined,
  foreign: e.foreign === 'true' ? 1 : e.foreign === 'false' ? 0 : undefined,
  gender: Array.isArray(e.gender) ? e.gender.map(__HiringGenderValue) : e.gender ? [__HiringGenderValue(e.gender)] : undefined,
  workType: Array.isArray(e.workType) ? e.workType.map(__JobPositionTypeValue) : e.workType ? [__JobPositionTypeValue(e.workType)] : undefined,
  time: Array.isArray(e.time) ? e.time.map(__JobTimeValue) : e.time ? [__JobTimeValue(e.time)] : undefined,
  experience: Array.isArray(e.experience) ? e.experience.map(__JobExperienceValue) : e.experience ? [__JobExperienceValue(e.experience)] : undefined,
  salaryType: Array.isArray(e.salaryType) ? e.salaryType.map(__JobSalaryTypeValue) : e.salaryType ? [__JobSalaryTypeValue(e.salaryType)] : undefined
});
export const __BrandDetailPath = (e: __BrandFilterType, language: LanguageEnum, brandSlug: string) => {
  const params: {
    [key: string]: string | string[];
  } = {};
  if (e.section) params.section = e.section;
  // common
  if (e.category) params.category = e.category;
  if (e.order) params.order = e.order;
  if (e.search) params.search = e.search;
  if (e.page) params.page = e.page;
  // service
  if (e.starGTE && e.starGTE !== 1) params.starGTE = e.starGTE.toString();
  if (e.starLTR && e.starLTR !== 5) params.starLTR = e.starLTR.toString();
  // hiring
  if (e.salaryGTE) params.salaryGTE = e.salaryGTE.toString();
  if (e.salaryLTE) params.salaryLTE = e.salaryLTE.toString();
  if (e.gender) params.gender = e.gender.toString();
  if (e.agreementSalary !== undefined) params.agreementSalary = JSON.stringify(e.agreementSalary);
  if (e.foreign !== undefined) params.foreign = e.foreign ? 'true' : 'false';
  const path = new URL(nextBrowser?.window?.location.origin + PATH(language).brand(brandSlug, params));

  // hiring
  if (typeof e.workType === 'number') path.searchParams.append('workType', e.workType.toString());else e.workType?.map(workType => path.searchParams.append('workType', workType.toString()));
  if (typeof e.time === 'number') path.searchParams.append('time', e.time.toString());else e.time?.map(time => path.searchParams.append('time', time.toString()));
  if (typeof e.experience === 'number') path.searchParams.append('experience', e.experience.toString());else e.experience?.map(experience => path.searchParams.append('experience', experience.toString()));
  if (typeof e.salaryType === 'number') path.searchParams.append('salaryType', e.salaryType.toString());else e.salaryType?.map(salaryType => path.searchParams.append('salaryType', salaryType.toString()));
  return path;
};